var _a;
import { Language } from 'src/shared/constants/languages';
export class DateHelper {
    constructor() {
        Object.defineProperty(this, "_locale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Language.En
        });
    }
    static getInstance() {
        if (!_a._instance) {
            _a._instance = new _a();
        }
        return _a._instance;
    }
    static getLocale() {
        return this.getInstance()._locale;
    }
}
_a = DateHelper;
Object.defineProperty(DateHelper, "setLocale", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (locale) => {
        _a.getInstance()._locale = locale;
    }
});
Object.defineProperty(DateHelper, "formatIsoString", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (isoString, options) => {
        try {
            return new Intl.DateTimeFormat(_a.getInstance()._locale, options).format(new Date(isoString));
        }
        catch {
            return isoString;
        }
    }
});
